









































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { IBarcodeCscanSetSpecification } from "../../../../../../domain/editableFormat/IFormatSpecification";

@Component
export default class CscanSettingSelectDialog extends Mixins(DialogMixin) {
  confirmed: boolean = false;
  sets: IBarcodeCscanSetSpecification[] = [];
  selectingSet: IBarcodeCscanSetSpecification = null;

  get setsCount(): number {
    return this.sets.length;
  }

  async show(sets: IBarcodeCscanSetSpecification[]): Promise<IBarcodeCscanSetSpecification> {
    this.sets = sets;
    return this.showModal(async () => {
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.selectingSet : null;
    });
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
